<script>
import baseMixin from '@/mixins/baseMixin'
import { RadioField } from '@/models/forms/fields/radioField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionRadioField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: RadioField,
      required: true,
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    compSelection() {
      const selection = this.field.options.find(
        (option) => option.value === this.value
      )

      if (!selection) return ''

      return selection.displayText
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      {{ compSelection }}
    </InfoLabel>
  </div>
</template>
